import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HeaderRenderer, HeaderRendererParams } from 'app/shared/components/smart-grid/core/interfaces/header-renderer.interface';
import { WorkProgressMaterialItem } from '../../interfaces/work-progress-material.interface';

@Component({
  selector: 'app-export-header-button',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, MatTooltipModule],
  template: `
    <button class="mr-4"
      mat-button
      color="primary"
      (click)="handleExport()"
      [matTooltip]="tooltip">
      <mat-icon class="text-current"
        [svgIcon]="'heroicons_outline:document-arrow-down'">
      </mat-icon>
    </button>
  `,
  styles: [`
    :host {
      display: flex;
      justify-content: center;
      width: 100%;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExportHeaderButtonComponent implements HeaderRenderer<WorkProgressMaterialItem> {
  @Input() params!: HeaderRendererParams<WorkProgressMaterialItem>;

  get tooltip(): string {
    return this.params?.colDef?.headerRendererParams?.params?.tooltip || 'Exportar';
  }

  handleExport(): void {
    const onExport = this.params?.colDef?.headerRendererParams?.params?.onExport;
    if (onExport && typeof onExport === 'function') {
      onExport();
    }
  }
}
